import Vue from 'vue';
import {
  Popup,
  Toast,
  Dialog,
} from 'vant';

Vue.use(Popup);
Vue.use(Toast);
Vue.use(Dialog);
